<div class="widget" [ngClass]="{'loader-shown': loading}">
  <div class="widget-loader widget-loader-news" [attr.aria-hidden]="loading ? 'false' : 'true'">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
      <div class="loader-element loader-right-icon"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-news-item">
        <div class="loader-element loader-image"></div>
        <div class="loader-text-container">
          <div class="loader-element loader-title"></div>
          <div class="loader-element loader-date"></div>
        </div>
      </div>
      <div class="loader-news-item">
        <div class="loader-element loader-image"></div>
        <div class="loader-text-container">
          <div class="loader-element loader-title"></div>
          <div class="loader-element loader-date"></div>
        </div>
      </div>
      <div class="loader-news-item">
        <div class="loader-element loader-image"></div>
        <div class="loader-text-container">
          <div class="loader-element loader-title"></div>
          <div class="loader-element loader-date"></div>
        </div>
      </div>
      <div class="loader-news-item">
        <div class="loader-element loader-image"></div>
        <div class="loader-text-container">
          <div class="loader-element loader-title"></div>
          <div class="loader-element loader-date"></div>
        </div>
      </div>
      <div class="loader-news-item">
        <div class="loader-element loader-image"></div>
        <div class="loader-text-container">
          <div class="loader-element loader-title"></div>
          <div class="loader-element loader-date"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="widget-header" [attr.aria-hidden]="loading ? 'true' : 'false'">
    <span class="custom-icon" aria-hidden="true">
      <span class="icon material-icons-round">feed</span>
    </span>
    <span class="title">News</span>
    <a
      *ngIf="widgetConfig.widgetSettings.showFullNewsButton"
      target="_blank"
      href="{{FEUrl}}{{widgetConfig.widgetSettings.newsPath}}"
      class="full-news-link"
      pTooltip="More News"
      aria-label="Explore more news"
    >
      <span class="icon material-icons" aria-hidden="true">launch</span>
    </a>
  </div>
  <div class="widget-content" [attr.aria-hidden]="loading ? 'true' : 'false'">
    <ng-container *ngFor="let newsItem of newsItems">
      <ng-container *ngIf="newsItem.data.fieldData.name">
        <a
          [href]="FEUrl + widgetConfig.widgetSettings.newsPath + '/' + newsItem.data.fieldData.slug"
          target="_blank"
          class="news-item"
          aria-label="Read more"
        >
          <div
            class="img-container"
            *ngIf="newsItem.data.fieldData['image']"
          >
            <img [src]="newsItem.data.fieldData['image'].url" [alt]="newsItem.data.fieldData['image'].alt">
          </div>
          <div class="text-container">
            <h5 class="news-title">{{newsItem.data.fieldData.name}}</h5>
            <span class="news-date" *ngIf="newsItem.compiledDate">{{newsItem.compiledDate}}</span>
          </div>
        </a>
      </ng-container>
    </ng-container>
  </div>
</div>